export class MathHelper {
    public static getRandomInt(maxNumber: number) {
        return Math.floor(Math.random() * maxNumber);
      }
}